import axios from 'axios'
import store from '@/store'
import storage from 'store2'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 3 * 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    // const data = error.response.data
    // 从 localstorage 获取 token
    // const token = storage.get(ACCESS_TOKEN)
    // if (error.response.status === 403) {
    //   notification.error({
    //     message: 'Forbidden',
    //     description: data.message
    //   })
    // }
    // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: 'Authorization verification failed'
    //   })
    //   if (token) {
    //     store.dispatch('Logout').then(() => {
    //       setTimeout(() => {
    //         window.location.reload()
    //       }, 1500)
    //     })
    //   }
    // }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    const noTokenApi = ['/v1/workflows/run'].find(i => config.url.includes(i))
    if (!noTokenApi) {
      config.headers[ACCESS_TOKEN] = 'Bearer ' + token
    }
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'application/vnd.ms-excel;charset=UTF-8') {
    return response
  }
  const data = response.data
  if (data.success !== 1) {
    if (data.success === 0 && data.errorMap.data === 'token无效') {
      notification.error({
        message: '提示',
        description: '身份验证过期'
      })
      store.commit('SET_TOKEN', '')
      if(process.env.VUE_APP_ELECTRON) {
        const { ipcRenderer } = require('electron')
        ipcRenderer.send('force-reload')
      } else {
        location.href = '/user/login'
      }
    }
    const noAlertApi = ['/api/tenant/logout', '/api/tenant/info', '/api/content/saveNote'].find(i => response.request.responseURL.includes(i))
    if (!noAlertApi) {
      notification.error({
        // message: data.errorMap?.data || data.errorMap?.error || '错误',
        message: '错误',
        description: data.errorMap?.data || data.errorMap?.error || '请求异常，请联系管理员',
        key: 'request_error'
      })
    }
  }
  return data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
